import React, { Suspense } from "react";
import {
  Col,
  Dialog,
  Divider,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";


import ErrorBoundary from "../../../utils/error-boundary";
import useOrganisationOwnershipService from "./use-beneficiary-service";

import { useToast } from "../../../context/toast-context";
import { BENEFICIARY_FORM_FIELDS } from "./beneficiary-constant";
import BeneficiaryList from "./beneficiary-list";

function EmployeeBeneficiary() {
  const {
    handleSubmitFn,
    getInputFieldPropsFn,
    employeeBenificiaryInput,
    createUpdateLoading,
    handleClickOpen,
    handleClose,
    open,
    setOpen,
    handleResetForm,
    resource,
    setSelectedFile,
    selectedFile,
    previewURL,
    setPreviewURL,
    openFileInNewTab,
    deleteDialogShow,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    handleDeleteNomineeFn,
    createFormUpdateLoading
  } = useOrganisationOwnershipService();
const { showToastMessage } = useToast();
  return (
    <>
      <ErrorBoundary
        fallback={<p>Something went wrong in fetching Owener list...</p>}
      >
        <Suspense fallback={<p>Loading Owener list...</p>}>
          <BeneficiaryList
            getInputFieldPropsFn={getInputFieldPropsFn}
            resource={resource}
            handleResetForm={handleResetForm}
            setOpen={setOpen}
            handleSubmitFn={handleSubmitFn}
            handleClickOpen={handleClickOpen}
            setSelectedFile={setSelectedFile}
            selectedFile={selectedFile}
            previewURL={previewURL}
            setPreviewURL={setPreviewURL}
            openFileInNewTab={openFileInNewTab}
            handleDeleteNomineeFn={handleDeleteNomineeFn}
            handleOpenDeleteDialog={handleOpenDeleteDialog}
            handleCloseDeleteDialog={handleCloseDeleteDialog}
            
          />
        </Suspense>
      </ErrorBoundary>

      <Gap height={50} />

      {/* Modal */}
      <Dialog
        title={`${employeeBenificiaryInput?.nominee_id ? "Update" : "Create New"}  Beneficiary`}
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        bodyScroll={true}
        separator
        loading={createUpdateLoading}
        buttonName={!employeeBenificiaryInput?.nominee_id ? "Save" : "Update"}
      >
        <>
          <Row rowGap>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.name.name)}
              />
            </Col>
            <Col sm={6}>
              <SelectField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.relationship.name)}
              />
            </Col>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.date_of_birth.name)}

              />
            </Col>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.contact_no.name)}
              />
            </Col>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.address.name)}
              />
            </Col>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.percentage_of_benefit.name)}
              />
            </Col>
            {/* <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.idProof.name)}
              />
            </Col> */}
            <Col sm={6}>
              <InputField
                type="file"
                fullWidth
                label="ID Proof"
                placeholder="Upload File"
                valueSinc={true}
                helperText={selectedFile?.name}
                onChange={(event) => {
                  const file = event.target.files[0];
                  if (file) {
                    const maxSizeInBytes = 2 * 1024 * 1024;
                    if (file.size > maxSizeInBytes) {
                      showToastMessage({
                        message: "File size should not exceed 2 MB.",
                        color: "danger",
                      });
                      return;
                    }
                    const allowedTypes = [
                      "image/jpeg",
                      "image/jpg",
                      "application/pdf",
                      "image/png",
                    ];

                    if (!allowedTypes.includes(file.type)) {
                      showToastMessage({
                        message: "Only JPG/PNG/PDF files are allowed.",
                        color: "danger",
                      });
                      return;
                    }
                    setSelectedFile(file);
                    setPreviewURL(URL.createObjectURL(file));
                  }
                }}
              />
            </Col>
          </Row>
          <Divider gap={20} />
          <Typography variant="h5">Bank Details</Typography>
          <Row rowGap>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.bank_name.name)}
              />
            </Col>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.account_number.name)}
              />
            </Col>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.ifcs.name)}
              />
            </Col>
          </Row>
        </>
      </Dialog>

      <Dialog
        title={`Confirm Delete`}
        fullWidth
        maxWidth="xs"
        closeButton={false}
        open={deleteDialogShow}
        onClose={handleCloseDeleteDialog}
        onSubmit={handleDeleteNomineeFn}
        btnLoading={createFormUpdateLoading}
        buttonName={"Delete"}
      >
        
        <Typography variant="body2" py={"20"}>Are you sure to delete Beneficiary details ?</Typography>
      </Dialog>
    </>
  );
}

export default EmployeeBeneficiary;
